<div 
[class.is-panel-visible]="isSidePanelVisible()" 
[class.is-panel-mobile-visible]="isMobileLeftPanel()" 
[class.is-panel-expanded]="isSidePanelExpanded()" 
style="height:100%;"
id="top-level"
>
  <div class="mobile-overhead">
    <div class="mobile-overhead-bar">
      <div class="btn-menu" (click)=openMobileLeftPanel() data-ui-name="Open Mobile Left Panel" data-ui-component="app-root" data-testid="app-root-open-mobile-left-panel">
        <i class="fa fa-bars" aria-hidden="true"></i>
      </div>
    </div>
  </div>
  <div style="height:100%;">
    <div class="page-content content" >
      <router-outlet data-ui-name="Router outlet" data-ui-component="app-root" data-testid="app-root-router-outlet"></router-outlet>
    </div>
    <div class="confirmation-modal"></div>
    <div #loginOverlay class="log-back-in modal-screen-cover" [class.is-hidden]="!(loginGuard.getLoginReq() | async)" style="z-index:5000;">
      <div class="modal-screen-cover-content is-boxed">
        <div class="modal-scrollpane">
          <login-form data-ui-name="Login form" data-ui-component="app-root" data-testid="app-root-login-form"></login-form>
        </div>
        <div class="delete-container">
          <button type="button" (click)="gotoHomeScreen()" class="delete is-large" [attr.aria-label]="lang.tra('btn_close')" data-ui-name="Goto Home Screen" data-ui-component="app-root" data-testid="app-root-goto-home-screen"></button>
        </div>
      </div>
    </div>
    <div class="connection-display tags">
      <warning-tag *ngIf="(loginGuard.getDevNetFail() | async)" slug="error_device_net" background="is-danger" data-ui-name="Warning tag" data-ui-component="app-root" data-testid="app-root-warning-tag">
      </warning-tag>
      <warning-tag *ngIf="(loginGuard.getApiNetFail() | async)" slug="error_server_net" data-ui-name="Warning tag" data-ui-component="app-root" data-testid="app-root-warning-tag-warning-tag">
      </warning-tag>
      <warning-tag *ngIf="(loginGuard.getAutoLogout() | async)" slug="alert_logged_out" data-ui-name="Warning tag" data-ui-component="app-root" data-testid="app-root-warning-tag-b706b01a">
      </warning-tag>
      <warning-tag *ngIf="(loginGuard.getAutoLogoutWarning() | async)" slug="alert_logging_out" dismissType="none" data-ui-name="Warning tag" data-ui-component="app-root" data-testid="app-root-warning-tag-category-selection-16265005">
        <br/>
        <a (click)="loginGuard.refreshLogin()" data-ui-name="Link logging out" data-ui-component="app-root" data-testid="app-root-link-logging-out"> <tra slug="link_logging_out"></tra> </a>
      </warning-tag>
      <warning-tag *ngIf="!imageLoad.allImageLoaded()" data-ui-name="Warning tag" data-ui-component="app-root" data-testid="app-root-warning-tag-category-selection-19d0bf3f">
        Some images are still loading
      </warning-tag>
      <warning-tag *ngIf="loginGuard.isIOS16_4_1" slug="ios_version_update_warning_msg" data-ui-name="Warning tag" data-ui-component="app-root" data-testid="app-root-warning-tag-category-selection-30d1487c">
      </warning-tag>
      <warning-tag *ngIf="(loginGuard.fontCheckFail | async)" slug="error_fonts_unloaded" data-ui-name="Warning tag" data-ui-component="app-root" data-testid="app-root-warning-tag-category-selection-3f76dd44">
      </warning-tag>
      <warning-tag *ngIf="(loginGuard.styleProfileCheck | async)" slug="error_style_profile_unloaded" data-ui-name="Warning tag" data-ui-component="app-root" data-testid="app-root-warning-tag-category-selection-464e4af2">
      </warning-tag>
    </div>
    <div class="device-net-fail-overlay modal-screen-cover" [class.is-hidden]="!isShowingDevNetFailOverlay">
      <div class="modal-screen-cover-content  is-boxed">
        <div class="modal-scrollpane">
          <div #deviceNetworkMessage class="popup-focus-target" tabindex="-1" data-ui-name="Offline warning" data-ui-component="app-root" data-testid="app-root-offline-warning">
            <tra slug="offline_warning"></tra>
          </div>
          <div>
            <button (click)="dismissDeviceNetworkOverlay()" class="button is-danger" data-ui-name="Dismiss notif" data-ui-component="app-root" data-testid="app-root-dismiss-notif">
              <tra slug="btn_dismiss_notif"></tra>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="api-net-fail-overlay modal-screen-cover" [class.is-hidden]="!isShowingApiNetFailOverlay">
      <div class="modal-screen-cover-content  is-boxed">
        <div class="modal-scrollpane">
          <div #apiNetworkMessage class="popup-focus-target" tabindex="-1" data-ui-name="Error server net long" data-ui-component="app-root" data-testid="app-root-error-server-net-long">
            <tra slug="error_server_net_long"></tra>
          </div>
          <hr/>
          <strong>Service Health</strong>
          <table class="table is-outlined is-bordered" style="margin-top: 1em;" data-ui-name="App root table" data-ui-component="app-root" data-testid="app-root-app-root-table">
            <tr data-ui-name="Current Status headings row" data-ui-component="app-root" data-testid="app-root-current-status-headings-row">
              <th>Current Status</th>
              <th>Current Details</th>
            </tr>
            <tr data-ui-name="✅ Registration values row" data-ui-component="app-root" data-testid="app-root-registration-values-row">
              <td>✅ Registration</td>
              <td>Service is operating normally</td>
            </tr>
            <tr data-ui-name="✅ Login values row" data-ui-component="app-root" data-testid="app-root-login-values-row">
              <td>✅ Login</td>
              <td>Service is operating normally</td>
            </tr>
            <tr data-ui-name="✅ Invigilation values row" data-ui-component="app-root" data-testid="app-root-invigilation-values-row">
              <td>✅ Invigilation</td>
              <td>Service is operating normally</td>
            </tr>
          </table>
          <hr/>
          <div>
            You may be receiving an error due to unusual traffic coming from your location. If you continue to experience a localized issue, please send <a target="_blank" href="https://www.google.com/search?q=what+is+my+ip&oq=what+is+my+ip" data-ui-name="Your IP address" data-ui-component="app-root" data-testid="app-root-your-ip-address">your IP address</a> to the technical support team (<a href="mailto:eqao-support@vretta.com" data-ui-name="Eqao support@vretta com" data-ui-component="app-root" data-testid="app-root-eqao-support-vretta-com">eqao-support@vretta.com</a>) so that the issue can be investigated.
          </div>
          <hr/>
          <div>
            <button (click)="dismissApiNetworkOverlay()" class="button is-warning" data-ui-name="Dismiss notif" data-ui-component="app-root" data-testid="app-root-dismiss-notif-dismiss-api-network-overlay"><tra slug="btn_dismiss_notif"></tra></button>
          </div>
        </div>
      </div>
    </div>
    <div class="support-overlay modal-screen-cover" [class.is-hidden]="!(loginGuard.getSupportReq() | async) ">
      <div class="modal-screen-cover-content  is-boxed is-wide">
        <div class="modal-scrollpane">
          <info-center-details [isAuthActive]="isAuthActive()" [supportCenterInfo]="loginGuard.getSupportReq() | async" (dismiss)="dismissSupportPopup()" data-ui-name="Info center details" data-ui-component="app-root" data-testid="app-root-info-center-details"></info-center-details>
        </div>
      </div>
    </div>
    <div
      class="confirmation-overlay modal-screen-cover"
      role="dialog"
      aria-modal="true"
      [cdkTrapFocus]="!!currentConfirmation"
      [class.is-hidden]="!currentConfirmation"
      style="z-index:5000; line-height: 1.3em"
      [style.font-size.em]="currentConfirmation?.fontSize" data-ui-name="App root div" data-ui-component="app-root" data-testid="app-root-app-root-div">
      <div
        class="modal-screen-cover-content  is-boxed"
        data-testid="confirmation-dialog"
        [attr.data-dialog]="currentConfirmation?.dialogId || null"
        [attr.aria-label]="currentConfirmation?.ariaLabel || null"
        [attr.aria-labelledby]="currentConfirmation?.ariaLabel ? null : 'confirmation-message-text'"
        [style.max-width]="setCustomWidth()">
        <div class="modal-scrollpane">
          <div #confirmationMessage id="confirmation-message-text" class="content confirmation-message" tabindex="-1" data-ui-name="App root div" data-ui-component="app-root" data-testid="app-root-app-root-div-app-root-div">
            <tra-md [slug]="getCurrentConfirmationCaption()" [props]="currentConfirmation?.props"></tra-md>
          </div>
          <div class="content" *ngIf="haveDescription()" style="width: 75%; margin: auto; text-align: center;">
            <tra-md [slug]="getCurrentConfirmationDescription()" [props]="currentConfirmation?.descriptionProps"></tra-md>
          </div>
          <div class="content" *ngIf="showDropDownCategories()" style="width: 75%; margin: auto">
            <label><tra [slug]="getCurrentConfirmationCategoriesLabel()"></tra></label>
            <select [(ngModel)]="categorySelection" (ngModelChange)="categorySelectionChange($event)" data-ui-name="Category Selection" data-ui-component="app-root" data-testid="app-root-category-selection">
              <option *ngFor="let catagory of currentConfirmation.catagoriesList" [value]="catagory" data-ui-name="Get Catagory Text(catagory) — category Selection" data-ui-component="app-root" data-testid="app-root-get-catagory-text-catagory-category-selection">{{getCatagoryText(catagory)}}</option>
            </select>
          </div>
          <div class="content" *ngIf="showExtraText()" style="width: 75%; margin: auto">
            <br>
            <textarea [(ngModel)]="extraTextInput" (ngModelChange)="extraTextAreaChange($event)" data-ui-name="Extra Text Input" data-ui-component="app-root" data-testid="app-root-extra-text-input"></textarea>
          </div>
          <br>
          <div class="content" *ngIf="showCurrentConfirmationSubCaption()" style="width: 75%; margin: auto">
            <tra-md [slug]="getCurrentConfirmationSubCaption()"></tra-md>
          </div>            
          <div *ngIf="showCurrentConfirmationInputBox()" class="modal-buttons">
            <input class="input" type="text" [(ngModel)]="confirmationInput" data-ui-name="Confirmation Input" data-ui-component="app-root" data-testid="app-root-confirmation-input">
          </div>
          <div *ngIf="showCurrentConfirmationCheckBox()" style="display:flex; margin-top:1em;">
            <div style="padding-top:0.3em;">
              <input type="checkbox" [(ngModel)]="confirmationCheckbox" id="confirmationCheckbox" data-ui-name="Confirmation Checkbox" data-ui-component="app-root" data-testid="app-root-confirmation-checkbox">
            </div>
            <div style="margin-left:1em;" class="text-checkbox"><label for="confirmationCheckbox"><tra-md [slug]="getCurrentConfirmationCheckBox()"></tra-md></label></div>
          </div>
          <div class="modal-buttons">
            <button class="button" style="font-size: 1.0em" [ngStyle]="getConfirmationBtnStyle(currentConfirmation?.btnCancelConfig)" (click)="closeModal()" data-testid="confirmation-cancel" [disabled]="isConfirmationPending" *ngIf="!hideCancel()" data-ui-name="Close Modal" data-ui-component="app-root">
              <ng-container *ngFor="let caption of confirmationCancelCaptions; let i = index">
                <tra audio-slug [slug]="caption"></tra>
                <span *ngIf="i !== confirmationCancelCaptions.length - 1">&nbsp;</span>
              </ng-container>              
            </button>
            <button class="button is-info" style="font-size: 1.0em" [ngStyle]="getConfirmationBtnStyle(currentConfirmation?.btnProceedConfig)" (click)="confirmModal()" data-testid="confirmation-proceed" [disabled]="blockConfirm()" *ngIf="!hideConfirm()" data-ui-name="Confirm Modal" data-ui-component="app-root">
              <ng-container *ngFor="let caption of confirmationProceedCaptions; let i = index">
                <tra audio-slug [slug]="caption"></tra>
                <span *ngIf="i !== confirmationProceedCaptions.length - 1">&nbsp;</span>
              </ng-container>               
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="confirmation-overlay modal-screen-cover" [class.is-hidden]="!isShowingInfoOverlay" style="z-index:5000;">
      <div class="modal-screen-cover-content is-boxed" style="background-color: #dcf3ff;padding-top:0em;">
        <button type="button" (click)="closeInfoOverlay()" class="close-button" [attr.aria-label]="lang.tra('btn_close')" data-ui-name="Close Info Overlay" data-ui-component="app-root" data-testid="app-root-close-info-overlay">
          <img src=" https://eqao.vretta.com/authoring/user_uploads/96360/authoring/Close/1621026645213/Close.svg" alt="" aria-hidden="true">
        </button>
        <div class="info-component-header">
          <div class="info-button">
            <img src="https://eqao.vretta.com/authoring/user_uploads/96360/authoring/Info/1621008934819/Info.svg">
          </div>
          <div #infoOverlayHeading class="heading-text popup-focus-target" tabindex="-1" data-ui-name="Instructions" data-ui-component="app-root" data-testid="app-root-instructions">
            &nbsp;
            Instructions
          </div>
        </div>
        <div class="modal-scrollpane">
          <div class="info-component">
            <img [src]="getBackPicUrl()">
             <span style="margin-left: 1em;">{{lang.tra("instruction_back")}}</span>
          </div>
          <div class="info-component">
            <img [src]="getNextPicUrl()">
            <span style="margin-left: 1em;">{{lang.tra("instruction_forward")}}</span>
          </div>
          <div class="info-component">
            <img [src]="getTextPicUrl()">
            <span style="margin-left: 1em;">{{lang.tra("instruction_open_text_info")}}</span>
          </div>
          <div class="info-component" style="margin-bottom:0em;">
            <img style="width:3em" src="https://eqao.vretta.com/authoring/user_uploads/96360/authoring/Question/1621021878125/Question.svg">
            <span style="margin-left: 1em;">{{lang.tra("instruction_open_page")}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="support-overlay modal-screen-cover" [class.is-hidden]="!(loginGuard.getHealthCheck() | async) "  style="z-index:5000;">
      <div class="modal-screen-cover-content  is-boxed is-wide" style="padding:2em; max-width:50em; max-height: 80vh; overflow:auto;">
        <tra-md [slug]="loginGuard.getHealthCheck().value.message"></tra-md>
      </div>
    </div>
  </div>
  <div class="content-shadow" (click)="closeMobileLeftPanel()" data-ui-name="Close Mobile Left Panel" data-ui-component="app-root" data-testid="app-root-close-mobile-left-panel"></div>
  <main-nav class="left-panel-container hide-on-paper" [class.is-hidden]="!isSidePanelVisible()" data-ui-name="Main nav" data-ui-component="app-root" data-testid="app-root-main-nav"></main-nav>
</div>
